import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import axios from 'axios';

import type {
    DeleteCustomLensRequest,
    DeleteCustomLensResponse,
} from 'components/molecules/PPA/Modals/CustomLense/customLens.types';
import { ppaUrls } from 'config/urls';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';
import { sendNotification } from 'utils/helperMethods';

import { InfoCircleFilled } from '@ant-design/icons';
import { createElement } from 'react';
import { colorConstants } from 'config/colorConstants';

type UseDeleteCustomLensResult = {
    loading: boolean;
    mutate: UseMutateFunction<DeleteCustomLensResponse, Error, DeleteCustomLensRequest, unknown>;
};

const showDeleteSuccessToast = (response: DeleteCustomLensResponse) => {
    if (response.fallback_applied) {
        return;
    }

    notification.success({
        duration: 5,
        icon: createElement(InfoCircleFilled, {
            style: { position: 'relative', top: -3, color: colorConstants.purpleFont },
        }),
        message: PricingSimulatorNotificationMessages.DELETE_CUSTOM_LENS_SUCCESS_TITLE,
        description: PricingSimulatorNotificationMessages.DELETE_CUSTOM_LENS_SUCCESS_DESCRIPTION,
        style: { width: 350, height: 'auto', borderRadius: 8 },
    });
};

export function useDeleteCustomLens(): UseDeleteCustomLensResult {
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async (payload: DeleteCustomLensRequest) => {
            const { data } = await axios.delete<DeleteCustomLensResponse>(
                ppaUrls.deleteCustomLensUrl(payload.lens_id),
            );
            return data;
        },
        onSuccess: (response) => {
            showDeleteSuccessToast(response);
        },
        onError: () => {
            sendNotification('error', PricingSimulatorNotificationMessages.GENERALIZED_ERROR_MSG);
        },
    });

    return {
        loading: isPending || isPaused,
        mutate,
    };
}

export default useDeleteCustomLens;
